import { useTheme } from '@audentio/stuff/src/ThemeProvider';
import { Box } from 'components/Box';
import { Flex } from 'components/Flex';
import {
    GridSection,
    GridSectionLeft,
    GridSectionRight,
} from 'components/GridSection';
import { Heading } from 'components/Heading';
import { Paragraph } from 'components/Paragraph';
import Img from 'gatsby-image';
import React from 'react';
import { ButtonGroup } from '../ButtonGroup';
import { Section } from '../Section';
import { ThemeProvider } from '../ThemeProvider';
import { Video } from '../Video';

export function MethodsLandingHero({
    image,
    video,
    videoPoster,
    videoId,
    title,
    subtitle,
    flipped = false,
    customMedia = null,
    mediaProps = {},
    sectionProps = {},
    buttons = [],
    buttonsProps = {},
    ...props
}: any) {
    const { sizes } = useTheme();
    const hasMedia = image || video || customMedia;

    return (
        <ThemeProvider defaultMode="dark">
            <Section
                wrap
                vertical="lg"
                backgroundColor="primaryBackground"
                pb={['40px', 'spacing-xl', null, null, 0]}
                maxWidth="containers.header"
                mb={{
                    _: 0,
                    xl: 'spacing-lg',
                }}
                // minH={['50vh', null, '40vh', null, '50vh']}
                {...sectionProps}
            >
                <GridSection
                    alignItems={{
                        _: 'flex-start',
                        md: 'center',
                    }}
                    {...(flipped
                        ? {
                              direction: { _: 'column', md: 'row-reverse' },
                          }
                        : {
                              direction: {
                                  _: 'column',
                                  md: 'row',
                              },
                          })}
                >
                    <GridSectionLeft
                        px={0}
                        mt={0}
                        maxWidth={{ _: '100%', md: '50%', xl: '40%' }}
                        // align media item with header, hero text with content
                        pl={{
                            _: 0,
                            xl: `calc((${sizes.containers.header} - ${sizes.containers.content}) / 2)`,
                        }}
                    >
                        <Flex
                            direction="column"
                            pb={{
                                _: 'spacing-lg',
                                md: 0,
                            }}
                        >
                            <Heading kind="h1">{title}</Heading>

                            <Box py="spacing">
                                <Paragraph
                                    fontSize="paragraphTitle"
                                    color="bodyText"
                                >
                                    {subtitle}
                                </Paragraph>
                            </Box>
                            {buttons && (
                                <ButtonGroup
                                    buttons={[...buttons]}
                                    py="spacing"
                                    {...buttonsProps}
                                />
                            )}
                        </Flex>
                    </GridSectionLeft>

                    {hasMedia && (
                        <GridSectionRight
                            {...(flipped
                                ? {
                                      pr: { _: 0, md: 20, lg: 32 },
                                  }
                                : {
                                      pl: { _: 0, md: 20, lg: 32 },
                                  })}
                            width="100%"
                            {...mediaProps}
                        >
                            <Box
                                width="100%"
                                d="flex"
                                zIndex={1}
                                alignItems={{
                                    xl: 'flex-end',
                                }}
                                transform={{
                                    xl: 'translateY(2rem)',
                                }}
                                minH={{
                                    _: 'unset',
                                    full: 455, // was 505
                                }}
                            >
                                {image && (
                                    <Box width="100%">
                                        <Img
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                            fluid={image}
                                        />
                                    </Box>
                                )}

                                {video && (
                                    <Box h="100%">
                                        <Video
                                            video={video}
                                            videoPoster={videoPoster}
                                            videoId={videoId}
                                        />
                                    </Box>
                                )}

                                {customMedia}
                            </Box>
                        </GridSectionRight>
                    )}
                </GridSection>
            </Section>
        </ThemeProvider>
    );
}
